import speedReadRoutes from './speedRead/routes';

export default [...speedReadRoutes];
